import {AbstractControl, type ValidationErrors} from '@angular/forms';
import dayjs from 'dayjs';

/**
 *  Validates that the end date/time is after the start date/time.
 *  Should be used on `ends` controls
 */
export function DateRangeValidator(control: AbstractControl): ValidationErrors | null {
  const ends = control.value;
  const starts = control.parent?.get('starts')?.value;
  if (!starts || !ends) {
    return null;
  }
  const isValid = dayjs(starts).isBefore(dayjs(ends));
  return isValid ? null : {dateRange: true};
}

export function DateRangeValidatorMessage(): string {
  return 'The end date/time must be after the start date/time.';
}
